import AxiosInstance from "@/http/axios.interceptor";

let API;

const http = (microServcName) => {
    API = AxiosInstance(microServcName);
    return {
        get,
        post,
        put,
        deleteReq
    };
};

// GET method
function get(endPoint, datas) {
    return API.get(endPoint, datas);
}

// POST method
function post(endPoint, datas) {
    return API.post(endPoint, datas);
}

// PUT method
function put(endPoint, datas) {
    return API.put(endPoint, datas);
}
//DELETE method
function deleteReq(endPoint, datas) {
    return API.delete(endPoint, datas);
}

export default http;
